export default __webpack_public_path__ + "static/cruiselines-carnival-kids-3-13a268aeb1274b5d1fa5b319004ffa34.jpg";